import React from 'react';
import { styled } from '@linaria/react';
import { colors } from '@spaceshipapp/cambridge';
import lighten from 'polished/lib/color/lighten';
import darken from 'polished/lib/color/darken';
import rgba from 'polished/lib/color/rgba';
import Button from './index';

// TODO: move this variant to design system
const DangerButton = styled(Button)`
  background-color: ${colors.error};
  color: ${colors.surface};

  &:hover:not([disabled]) {
    background-color: ${lighten(0.23, colors.error)};
  }

  &:focus {
    background-color: ${colors.error};
  }

  &:active:not([disabled]) {
    box-shadow: inset 0 0 0 2px ${darken(0.1, colors.error)};
    background-color: ${colors.error};
  }

  &:disabled,
  &[disabled] {
    background-color: ${rgba(colors.error, 0.5)};

    &:after {
      border: 2px dashed ${darken(0.1, colors.error)};
    }
  }
`;

export default DangerButton;
